export const API_KEY = "6332f54a56bc405580065501221312";
export const BASE_URL = "https://api.weatherapi.com/v1";
